var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF7A00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 15.66C25.9401 15.65 25.8701 15.65 25.8101 15.66C24.4301 15.61 23.3301 14.48 23.3301 13.08C23.3301 11.65 24.4801 10.5 25.9101 10.5C27.3401 10.5 28.4901 11.66 28.4901 13.08C28.4801 14.48 27.3801 15.61 26.0001 15.66Z",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9699 22.9402C26.3399 23.1702 27.8499 22.9302 28.9099 22.2202C30.3199 21.2802 30.3199 19.7402 28.9099 18.8002C27.8399 18.0902 26.3099 17.8502 24.9399 18.0902",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 15.66C14.03 15.65 14.1 15.65 14.16 15.66C15.54 15.61 16.64 14.48 16.64 13.08C16.64 11.65 15.49 10.5 14.06 10.5C12.63 10.5 11.48 11.66 11.48 13.08C11.49 14.48 12.59 15.61 13.97 15.66Z",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 22.9402C13.6299 23.1702 12.1199 22.9302 11.0599 22.2202C9.64994 21.2802 9.64994 19.7402 11.0599 18.8002C12.1299 18.0902 13.6599 17.8502 15.0299 18.0902",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 23.1297C19.9401 23.1197 19.8701 23.1197 19.8101 23.1297C18.4301 23.0797 17.3301 21.9497 17.3301 20.5497C17.3301 19.1197 18.4801 17.9697 19.9101 17.9697C21.3401 17.9697 22.4901 19.1297 22.4901 20.5497C22.4801 21.9497 21.3801 23.0897 20.0001 23.1297Z",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0902 26.2794C15.6802 27.2194 15.6802 28.7594 17.0902 29.6994C18.6902 30.7694 21.3102 30.7694 22.9102 29.6994C24.3202 28.7594 24.3202 27.2194 22.9102 26.2794C21.3202 25.2194 18.6902 25.2194 17.0902 26.2794Z",
    stroke: "#FF7A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserlogo);
export default __webpack_public_path__ + "static/media/userlogo.c596289ae89e190ed1a660a87220783a.svg";
export { ForwardRef as ReactComponent };